import React from 'react';

import MixedContent from '../MixedContent';
import Title from '../Title';

export const TitleContent = ({ value: { title, body }, ...props }) => {
  const headingLevel = (Number(props.headingLevel) || 0) + 1;

  return (
    <React.Fragment>
      <Title {...props} value={title} />
      <MixedContent {...props} headingLevel={headingLevel} value={body} />
    </React.Fragment>
  );
};

export default TitleContent;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/TitleContent/index.js